module.exports = __webpack_public_path__ + "static/img/sjsl.cb32bb72.png";